angular.module('cfn').factory('coreUnitService', coreUnitService);

coreUnitService.$inject = ['$log', 'unitConverter'];

function coreUnitService($log, unitConverter) {
  // Exported service
  return {
    updateOptions: updateOptions
  };
  ////////////

  /**
   * Returns a virtual group name that can be compared to determine if
   * units can be converted to each other
   *
   * @param {string}
   *            unit - unit to query the virtual group name for
   */
  function getCompatibleGroup(unit) {
    var group = unitConverter.getGroup(unit);
    if (group === 'LIQUID' || group === 'VOLUME') {
      // these two are compatible, so aggregate
      group = 'LIQUID_OR_VOLUME';
    } else if (group === 'QUANTITY') {
      if (unit === 'QUANTITY_UNIT' || unit === 'QUANTITY_GRAIN') {
        //exception CFNPOC-8580
        group = 'QUANTITY_GRAIN_OR_UNIT';
      } else {
        // Do not group quantity items as they are not convertible
        group = unit;
      }
    }
    return group;
  }

  /**
   * Returns available stockyard units for a given main unit
   *
   * @param {string}
   *            mainUnit - selected main unit
   * @param {Array}
   * 			  allowedUnits - allowed subset of units
   *
   */
  function getStockyardUnitOptions(mainUnit, allowedUnits) {
    var allowedUnits = allowedUnits || [];
    var unitGroups = {};

    // group all options (group_id -> [units_in_same_group])
    var result = {};
    allowedUnits.forEach(function(v) {
      var group = getCompatibleGroup(v);
      if (!result[group]) result[group] = [];
      result[group].push(v);
    });
    // link them all together (unit -> [units_in_same_group])
    for (var g in result) {
      var values = result[g];

      values.forEach(function(v) {
        unitGroups[v] = values;
      });
    }

    return result[getCompatibleGroup(mainUnit)]
      ? result[getCompatibleGroup(mainUnit)]
      : allowedUnits;
  }

  /**
   * Makes sure that the stockyard unit is in the same group as the main unit. If not, change
   * it to a default value in the correct group.
   *
   * @param {string}
   * 				mainUnit - main unit that decides the group
   * @param {string}
   * 				stockyardUnit - current stockyard unit
   *
   * @return correct stockyard unit
   */
  function ensureStokyardUnitInCorrectGroup(
    mainUnit,
    stockyardUnit,
    allowedUnits
  ) {
    var allowedUnits = allowedUnits || [];
    var supplyUnitGroup = getCompatibleGroup(mainUnit),
      stockyardUnitGroup = getCompatibleGroup(stockyardUnit);

    // Incompatible group or previous stockard is not allowed anymore.
    if (
      supplyUnitGroup !== stockyardUnitGroup ||
      allowedUnits.indexOf(stockyardUnit) == -1
    ) {
      var defaultUnitInGroup = unitConverter.min(
        getStockyardUnitOptions(mainUnit, allowedUnits)
      );
      $log.info(
        'Changing stockyard unit from ' +
          stockyardUnit +
          ' to ' +
          defaultUnitInGroup
      );
      stockyardUnit = defaultUnitInGroup;
    }
    return stockyardUnit;
  }

  /**
   * called when a unit has been modified.
   * It is expected that the names of the unit/stockyard variables in the model are:
   * xxxUnit with xxxUnitOptions and xxxStockyardDisplayUnit and xxxStockyardDisplayUnitOptions
   *
   * where xxx is some base representation (i.e. seed, harvest, etc)
   *
   * model := the model storing the info
   * originalOptions := the original options from which to choose.
   * options := options for this update logic:
   * 		entity := the entity name of the unit (e.g. seed from seedUnit, harvest)
   *
   *
   */
  function updateOptions(model, originalOptions, options) {
    if (!model) return;
    var unitName, stockyardUnitName;
    var option = options || {};

    //setup the default names
    if (!option.entity) {
      var unitName = 'unit',
        stockyardUnitName = 'stockyardDisplayUnit';
    } else {
      var unitName = option.entity + 'Unit',
        stockyardUnitName = option.entity + 'StockyardDisplayUnit';
    }

    var unitOptions = unitName + 'Options',
      stockyardDisplayUnitOptions = stockyardUnitName + 'Options';

    //if model changes, make sure we find the place where this is called...
    if (!model[unitName]) {
      $log.error(
        'Missing expected unit %s in model for entity %s: %s',
        unitName,
        option.entity,
        new Error().stack
      );
      return;
    }
    if (!model[stockyardUnitName]) {
      $log.error(
        'Missing expected stockyard unit %s in model for entity %s: %s',
        stockyardUnitName,
        option.entity,
        new Error().stack
      );
      return;
    }

    var unit = model[unitName],
      stockyardUnit = model[stockyardUnitName];

    //only change values when we have a better one
    // Stockyard unit selection depends on selected supply unit
    var resolvedStockyardDisplayUnitOptions = getStockyardUnitOptions(
      unit,
      originalOptions
    );
    if (resolvedStockyardDisplayUnitOptions)
      model[stockyardDisplayUnitOptions] = resolvedStockyardDisplayUnitOptions;

    //make sure the current selected unit is valid within all options, or set it properly if not.
    var resolvedStockyardUnitName = ensureStokyardUnitInCorrectGroup(
      unit,
      stockyardUnit,
      model[stockyardDisplayUnitOptions]
    );
    if (resolvedStockyardUnitName)
      model[stockyardUnitName] = resolvedStockyardUnitName;
  }
}

export default coreUnitService;
